import { newlineToBr } from "@/utils/text-transformation";
import { required } from "@vuelidate/validators";
import { tel } from "@/utils/form-validators";
import { formValidationProps, useFormValidation } from "@/components/organisms/mixins/form-validation.mixin";
import { useVuelidate } from "@vuelidate/core";

export const infoComplementairesProps = () => ({
  addresseLad: {
    type: Object,
    required: false
  },
  infosLegales: {
    type: String,
    required: false
  },
  ...formValidationProps()
})

export const infoComplementairesEmits = () => ([
  "validate"
])

export const useInfoComplementaires = (props, context) => {
  const {
    getState,
    getErrorMessage,
    checkValidation
  } = useFormValidation(props)

  const forceUpdate = ref(0)
  const isInfoLivraisonChanged = ref(false)
  const newAddresseLad = ref(props.addresseLad.attributes)

  const validations = computed(() => ({
    newAddresseLad: {
      info_livreur: {},
      tel: {
        required,
        tel
      }
    }
  }))

  const v$ = useVuelidate(validations, { newAddresseLad })

  const infosLegalesFormatted = computed(() => {
    if (props.infosLegales) {
      return newlineToBr(props.infosLegales);
    }
    return "";
  })

  const change = () => {
    isInfoLivraisonChanged.value = true;
  }
  const validate = () => {
    if (checkValidation(v$.value)) {
      context.emit(
        "validate",
        isInfoLivraisonChanged.value ? newAddresseLad.value : null
      );
    }
  }

  watch(() => props.addresseLad, () => {
    forceUpdate.value++;
    newAddresseLad.value = value.attributes;
    isInfoLivraisonChanged.value = false;
  })

  return {
    getState,
    getErrorMessage,
    forceUpdate,
    isInfoLivraisonChanged,
    newAddresseLad,
    validations,
    v$,
    infosLegalesFormatted,
    change,
    validate
  }
}
